export const SET_SIMULATION_LEVEL = 'SET_SIMULATION_LEVEL',
  TOGGLE_NOTEBOOK_COLLAPSE = 'TOGGLE_NOTEBOOK_COLLAPSE',
  SET_NOTEBOOK_SECTION = 'SET_NOTEBOOK_SECTION',
  DDQ_DROPDOWN_CHANGE = 'DDQ_DROPDOWN_CHANGE',
  DDQ_SUBMIT_ANSWER = 'DDQ_SUBMIT_ANSWER',
  DNDQ_SELECT_SEQUENCE = 'DNDQ_SELECT_SEQUENCE',
  DNDQ_SUBMIT_ANSWER = 'DNDQ_SUBMIT_ANSWER',
  GROUPED_DNDQ_SELECT_SEQUENCE = 'GROUPED_DNDQ_SELECT_SEQUENCE',
  GROUPED_DNDQ_SUBMIT_ANSWER = 'GROUPED_DNDQ_SUBMIT_ANSWER',
  MSCQ_SELECT_OPTION = 'MSCQ_SELECT_OPTION',
  MSCQ_SUBMIT_ANSWER = 'MSCQ_SUBMIT_ANSWER',
  SELECT_QUESTION_OPTION = 'SELECT_QUESTION_OPTION',
  SUBMIT_QUESTION_ANSWER = 'SUBMIT_QUESTION_ANSWER',
  SLIDE_ONE_DRAG_DROP = 'SLIDE_ONE_DRAG_DROP',
  SLIDE_ONE_REMOVE_DROP = 'SLIDE_ONE_REMOVE_DROP',
  SLIDE_ONE_SET_AS_NEXT_STEP = 'SLIDE_ONE_SET_AS_NEXT_STEP',
  SET_NEW_CURRENT_DESIGN_SLIDE = 'SET_NEW_CURRENT_DESIGN_SLIDE',
  SLIDE_TWO_DRAG_DROP = 'SLIDE_TWO_DRAG_DROP',
  SLIDE_TWO_SET_AS_NEXT_STEP = 'SLIDE_TWO_SET_AS_NEXT_STEP',
  SLIDE_TWO_REMOVE_STEP = 'SLIDE_TWO_REMOVE_STEP',
  SLIDE_TWO_APPLY_HINT = 'SLIDE_TWO_APPLY_HINT',
  SLIDE_TWO_SELECT_PATH = 'SLIDE_TWO_SELECT_PATH',
  SLIDE_THREE_DRAG_DROP = 'SLIDE_THREE_DRAG_DROP',
  SLIDE_THREE_REMOVE_DROP = 'SLIDE_THREE_REMOVE_DROP',
  SLIDE_THREE_SET_AS_NEXT_STEP = 'SLIDE_THREE_SET_AS_NEXT_STEP',
  SLIDE_THREE_APPLY_HINT = 'SLIDE_THREE_APPLY_HINT';
